import { Action, ActionType } from "@redux/actionTypes/currencydateFormatActionType";
import { Reducer } from "react";

export interface ICurrencyDateFormatState {
  currencydateFormatDetails: ICurrencyDateFormatDetails[];
}

export interface ICurrencyDateFormatDetails {
  dateFormat: string;
  dateFormatId: number;
}

const initialState = {
  currencydateFormatDetails: [],
};

export const currencydateFormatReducer: Reducer<ICurrencyDateFormatState, Action> = (state = initialState, action) => {
  switch (action.type) {
    case ActionType.API_CURRENCY_DATE_FORMAT:
      return {
        ...state,
        currencydateFormatDetails: action.payload,
      };
    case ActionType.RESET_REDUX_STATE: {
      return initialState;
    }
    default:
      return state;
  }
};
